module.exports = __webpack_public_path__ + "assets/img/bg@2x.90586b2c.png";